import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';

import Form, { ButtonItem, GroupItem, Label, SimpleItem } from 'devextreme-react/form';
import ValidationGroup from 'devextreme-react/validation-group';

import { useAuth } from 'context/auth';

import { useLazyGetContractorDetailInfoQuery } from 'bus/contractor/services/services';
import {
  useChangeContractorLegalMutation,
  useLazyGetContractorLegalSearchBankDetailsQuery,
} from 'bus/contractorLegal/services/services';
import { ContractorLegalBankDetail, ContractorLegalItem } from 'bus/contractorLegal/types';

import { initialStateForm } from '../../Views/ContractorLegalList/utils';

const BankDetails: FC = () => {
  let { id } = useParams<{ id: string }>();
  const { getClaims }: any = useAuth();
  let createCatalogGroupRef = useRef<any>(null);

  const [changeContractorLegal] = useChangeContractorLegalMutation();
  const [getContractorLegalSearchBankDetails] = useLazyGetContractorLegalSearchBankDetailsQuery();

  const [form, setForm] = useState<ContractorLegalItem>({ ...initialStateForm });

  const [getContractorDetailInfo] = useLazyGetContractorDetailInfoQuery();

  const getData = useCallback(async () => {
    const data = await getContractorDetailInfo({ id }).unwrap();
    setForm((prev) => ({ ...prev, ...data }));
  }, [getContractorDetailInfo, id]);

  useEffect(() => {
    getData();
  }, [getData]);

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    if (createCatalogGroupRef.current.instance.validate().isValid) {
      await changeContractorLegal(form);
      toast.success('Успешно сохранено', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      getData();
    }
  };

  const searchBankDetail = async () => {
    const result: ContractorLegalBankDetail = await getContractorLegalSearchBankDetails({ bik: form.bik }).unwrap();
    setForm((prev) => ({ ...prev, ...result }));
  };

  const searchButton = {
    name: 'search',
    options: {
      onClick: () => searchBankDetail(),
      icon: 'search',
      type: 'default',
      stylingMode: 'text',
    },
  };

  const isCanEditLegalContractor = !getClaims(['CanEditLegalContractor']);

  return (
    <div className="pa-2" style={{ width: 600 }}>
      <form onSubmit={handleSubmit}>
        <ValidationGroup>
          <Form formData={form} ref={createCatalogGroupRef} readOnly={isCanEditLegalContractor}>
            <GroupItem cssClass="first-group" colCount={12}>
              <SimpleItem
                dataField="bik"
                colSpan={12}
                editorOptions={{
                  buttons: [searchButton],
                }}
              >
                <Label text="БИК" />
              </SimpleItem>
              <SimpleItem dataField="bankName" colSpan={12}>
                <Label text="Банк" />
              </SimpleItem>
              <SimpleItem dataField="bankAddress" colSpan={12}>
                <Label text="Адрес банка" />
              </SimpleItem>
              <SimpleItem dataField="rs" colSpan={12}>
                <Label text="Расчетный счет" />
              </SimpleItem>
              <SimpleItem dataField="ks" colSpan={12}>
                <Label text="Кор. счет" />
              </SimpleItem>
            </GroupItem>

            <ButtonItem
              horizontalAlignment="left"
              buttonOptions={{
                text: 'Сохранить',
                type: 'success',
                useSubmitBehavior: true,
                disabled: isCanEditLegalContractor,
              }}
            />
          </Form>
        </ValidationGroup>
      </form>
    </div>
  );
};

export default BankDetails;
